import { Icon } from 'pcln-icons';
Icon.isIcon = true;
export default Icon;
//# sourceMappingURL=Icon.js.map